module.exports = __webpack_public_path__ + "static/img/20241224_3.35bf4ed.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/2024/20241224_3.png
// module id = //LG
// module chunks = 0